import React, { useState, useEffect, useMemo } from 'react';
import { Calendar } from 'lucide-react';

const MONTHS = [
  { value: '1', label: 'Janeiro' },
  { value: '2', label: 'Fevereiro' },
  { value: '3', label: 'Março' },
  { value: '4', label: 'Abril' },
  { value: '5', label: 'Maio' },
  { value: '6', label: 'Junho' },
  { value: '7', label: 'Julho' },
  { value: '8', label: 'Agosto' },
  { value: '9', label: 'Setembro' },
  { value: '10', label: 'Outubro' },
  { value: '11', label: 'Novembro' },
  { value: '12', label: 'Dezembro' },
];

const AppointmentsMonthSummary = ({
  monthlyAggregates = [],
  availableYears = [],
}) => {
  const now = new Date();
  const [yearFilter, setYearFilter] = useState(() => String(now.getFullYear()));
  const [monthFilter, setMonthFilter] = useState(() => String(now.getMonth() + 1));

  const years = availableYears.length > 0
    ? availableYears
    : [now.getFullYear()];

  useEffect(() => {
    if (!years.includes(parseInt(yearFilter, 10))) {
      setYearFilter(String(years[0]));
    }
  }, [years, yearFilter]);

  const count = useMemo(() => {
    const year = parseInt(yearFilter, 10);

    if (!monthFilter) {
      return monthlyAggregates
        .filter((a) => a.year === year)
        .reduce((sum, a) => sum + a.count, 0);
    }

    const month = parseInt(monthFilter, 10);
    const entry = monthlyAggregates.find((a) => a.year === year && a.month === month);
    return entry?.count ?? 0;
  }, [monthlyAggregates, yearFilter, monthFilter]);

  const monthLabel = MONTHS.find((m) => m.value === monthFilter)?.label ?? '';
  const periodDescription = monthFilter
    ? `em ${monthLabel} de ${yearFilter}`
    : `no ano de ${yearFilter}`;

  return (
    <div className="card">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h3 className="text-lg font-semibold text-foreground">
          Agendamentos
        </h3>
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex items-center space-x-2">
            <Calendar className="w-4 h-4 text-primary-600" />
            <select
              value={yearFilter}
              onChange={(e) => setYearFilter(e.target.value)}
              className="input-field max-w-xs"
            >
              {years.map((year) => (
                <option key={year} value={year.toString()}>{year}</option>
              ))}
            </select>
          </div>
          <div className="flex items-center space-x-2">
            <Calendar className="w-4 h-4 text-primary-600" />
            <select
              value={monthFilter}
              onChange={(e) => setMonthFilter(e.target.value)}
              className="input-field max-w-xs"
            >
              <option value="">Todos</option>
              {MONTHS.map((month) => (
                <option key={month.value} value={month.value}>{month.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center py-8 text-center">
        <p className="text-5xl font-bold text-primary-600">
          {count.toLocaleString('pt-BR')}
        </p>
        <p className="mt-2 text-base text-muted-light dark:text-muted-dark">
          {count === 1 ? 'agendamento' : 'agendamentos'} {periodDescription}
        </p>
      </div>
    </div>
  );
};

export default AppointmentsMonthSummary;
